/**
 * Create Task Flow
 * 
 * Guides users through creating their first task.
 * Triggers when the add task button is clicked for the first time.
 */

import { SquiggleFlow } from '../types';

export const createTaskFlow: SquiggleFlow = {
  id: 'createTask.v1',
  version: 1,
  title: 'Create Your First Task',
  priority: 80,
  enabledByDefault: true,
  
  gating: {
    oncePerUser: false,
    oncePerSession: true,
    prerequisites: [
      { type: 'hasCompleted', key: 'welcome.v1', equals: true },
    ],
  },
  
  triggers: [
    { type: 'event', name: 'task:create:opened' },
  ],
  
  steps: [
    {
      id: 'arrive',
      action: { 
        kind: 'moveTo', 
        target: { type: 'viewport', x: 0.75, y: 0.3 },
        arrival: { durationMs: 500, trail: 'draw' }
      },
    },
    {
      id: 'set-curious',
      action: { kind: 'setMood', mood: 'curious' },
    },
    {
      id: 'intro',
      action: {
        kind: 'speak',
        text: "Great! Let's create your first task. Give it a name that your child will understand.",
        bubble: { 
          placement: 'left', 
          showDismiss: true,
        },
      },
    },
    {
      id: 'wait-name',
      action: { 
        kind: 'waitFor', 
        condition: { 
          type: 'inputNotEmpty', 
          target: { type: 'anchor', id: 'task.nameInput' } 
        } 
      },
      timeoutMs: 30000,
      optional: true,
    },
    {
      id: 'encourage',
      action: { kind: 'setMood', mood: 'happy' },
    },
    {
      id: 'tip',
      action: {
        kind: 'speak',
        text: "You can pick an emoji icon and choose how long this task takes. Kids love visual cues! 🎨",
        bubble: { 
          placement: 'left', 
          showDismiss: true,
        },
      },
    },
    {
      id: 'wait-save',
      action: { 
        kind: 'waitFor', 
        condition: { type: 'event', name: 'task:created' } 
      },
      timeoutMs: 60000,
      optional: true,
    },
    {
      id: 'celebrate',
      action: { kind: 'gesture', name: 'celebrate' },
    },
    {
      id: 'congrats',
      action: {
        kind: 'speak',
        text: "Awesome! You created your first task! 🎉 Keep adding more to build a complete routine.",
        bubble: { 
          placement: 'left', 
          showDismiss: true,
        },
      },
    },
    {
      id: 'wait-dismiss',
      action: { 
        kind: 'waitFor', 
        condition: { type: 'ms', durationMs: 3000 } 
      },
      timeoutMs: 5000,
    },
  ],
  
  onExit: {
    clearTrail: true,
    mood: 'idle',
    returnHome: true,
  },
};

export default createTaskFlow;
